import React from 'react'
import { Field } from 'redux-form'

import 'antd/dist/antd.css'
import {COSMOS_DEF_MAX_ALL_ADV_DAYS,COSMOS_DEF_SEARCH_ADV_DAYS,COSMOS_DEF_ROUND_ADV_DAYS_O,COSMOS_DEF_ROUND_ADV_DAYS_D} from '../../constants'
import { DatePicker } from 'antd';

import moment from 'moment'

export class SVMCIInputEp extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.svmdcCurryCom = this.svmdcCurryCom.bind(me)
        this.state = {
            filters: {

                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
                // "endDate": "2024-07-22T25:42:55.795+00:00" ,
                startDate: new Date()
            }
        }


    }
    disabledDate = (curDate) => {
        console.log('disabledDate***SEP4*** called')
        let isValid = false, isMinValid = false, isMaxValid = false

        let daysMax = 0, days = 0
        let today = moment(), todayMax = moment()
        let minMom = null, maxMom = null
        // const {COSMOS_DEF_SEARCH_ADV_DAYS} 
         let  advBy = parseInt(COSMOS_DEF_SEARCH_ADV_DAYS) ? parseInt(COSMOS_DEF_SEARCH_ADV_DAYS) : 13
         let  advEndBy = parseInt(COSMOS_DEF_MAX_ALL_ADV_DAYS) ? parseInt(COSMOS_DEF_MAX_ALL_ADV_DAYS) : 364
         
        
        if(today){
            minMom = today.add(advBy, 'days')
        }
          days = minMom.diff(curDate)
         if( days > 0){
            isMinValid = true
           // isValid = true
         }
         
         
        
         if(todayMax){
            maxMom = today.add( advEndBy, 'days')
        }

         daysMax = maxMom.diff(curDate)
         console.log(daysMax)
         if( daysMax < 0){
            isMaxValid = true
           // isValid = true
        }
        
        
        if( (isMaxValid === true) || (isMinValid === true)){
            isValid = true
        }else{
            isValid = false
        }
        
         //cannot be less than a 


        return isValid
      }
      disabledDateR = (curDate1, curDate2) => {
        let isValidR = false
        let isValid1 = false
        let isValid2 = false
        console.log('disabledDateR rangepicker***SEP4*** called')
       
        isValid1 = this.disabledDate(curDate1)

        if( (isValid1 === true)){
            isValidR = true
        }else{
            isValidR = false
        }
        
        return isValidR



      }
    svmdcCurryCom = (param1, ctxThis) => (o) => {
        console.log("*******svj22****curry** START")
        console.log(param1)

        console.log(ctxThis)

        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******svj22****redux vaalue**")
        console.log(value)
        let vob = value
        let vob_date = value._d
        console.log(vob_date)
        let STARTDATE_ITN_TZAWARE_EST = "2025-11-25"
        let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
        let mofval = null
        if (value != null) {
            mofval = moment(vob_date)
            let mofval_str = mofval.format('YYYY-MM-DD')

            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)



            let mom_value = !value ? mo_ss : mofval_str
        } else {
            mofval = mo_ss
        }

        let TIME_NO = false



        return (<DatePicker showTime={TIME_NO} disabledDate={this.disabledDate}  onChange={onChange} value={mofval} />)


    }
    render() {
        console.log('render SVMCIInputEp date add')

        let me = this
        let { member } = this.props

        let param1 = "1974-01-14"


        return (

            <Field 
            
            name={`${member}.STARTDATE`}
                className="form-control"
                component={this.svmdcCurryCom(param1, this)}
            />
        )


    }

}